import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  EstadoComponente,
} from "@/shared/components/ui";
import {
  useFetchSolicitudesEgreso,
} from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  EstadosSolicitudPeodidoEnum,
  IDataProducto,
} from "@/shared/interfaces";
import { Button, Chip, Grid } from "@mui/material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useEffect, useState } from "react";

import { useMemo } from "react";


import VisibilityIcon from '@mui/icons-material/Visibility';
import { PermissionsEnum } from "@/auth/interfaces";
import { SolicitudesEgreso } from "@/shared/interfaces/erp/compras/solicitudes-egreso.interface";
import { cellNotFilter, formatDateWithTimeCell } from "@/shared";
import { useSinSeriesProducto } from "@/store/erp/productos/sinSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
type DetalleUsuarios = {
  id?: number;
  estado_solicitud?: string;
  motivo_rechazo?: string;
};

export default function SolicitudPedidosUsuariosfinalizadosPagina() {
  useCheckPermissions(PermissionsEnum.api_view_solicitudegreso);
  //*store
  const handleCargarListaProductos = useSinSeriesProducto(s => s.handleCargarListaProductos)
  const listaProductos = useSinSeriesProducto(s => s.listaProducto)
  const paginatedProductoData = useSinSeriesProducto(s => s.paginatedProductoData)
  const paginationTable = useSinSeriesProducto(s => s.pagination)
  const setpaginationTable = useSinSeriesProducto(s => s.setPagination)
  const clearSelectedItems = useSinSeriesProducto(s => s.clearSelectedItems)
  //state
  const [isModalOpen, setIsModalOpen] = useState(false);
  //const [details, setDetails] = useState<IDataProducto[]>([]);


  const columns = useMemo<MRT_ColumnDef<DetalleUsuarios>[]>(
    () => [
      {
        ...cellNotFilter,
        accessorKey: "detalles",
        header: "producto",
        size: 20,
        width: 20,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              color="primary"
              onClick={() => {
                onDetails(row.original);
              }}
              startIcon={<VisibilityIcon />}
            >
              {'Ver'}
            </Button>
          );
        },
      },
      {
        accessorKey: "numero_referencia",
        header: "N° solicitud",
        size: 200,
        width: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "user.username",
        header: "usuario",
        size: 20,
        width: 20,
      },
      {
        ...cellNotFilter,
        accessorKey: "bodega_data.nombre",
        header: "bodega",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "Fecha de creacion",
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },

      {
        ...cellNotFilter,
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) => (
          row.original.estado_solicitud != null ?
            <EstadoComponente backgroundColor="green" texto={row.original.estado_solicitud || ''} /> : null
        ),
      },

    ],
    []
  );

  // const onDetails = (e: MRT_RowData) => {
  //   handleCargarListaProductos(e.productos)
  //   //setDetails(JSON.parse(JSON.stringify(e.productos)));
  //   setIsModalOpen(true);
  // };
  const onDetails = (e: MRT_RowData) => {
    const registros: any[] = e.registros_diferencia || [];
    // suma metros enviados por código de producto (por si hubo parciales)
    const mapaEnviados = registros.reduce<Record<string, number>>((acc, r) => {
      const cod = String(r.producto);
      acc[cod] = (acc[cod] ?? 0) + Number(r.metros_enviados ?? 0);
      return acc;
    }, {});

    const productos = (e.productos || []).map((p: any) => {
      const usaMetros = p.cantidad_metros != null && p.cantidad_metros !== '';
      if (!usaMetros) return p;
      const cod = String(p.codigo);
      const solicitados = Number(p.cantidad_metros ?? 0);
      // si no hay registro para ese producto => se envió lo que se pidió
      const enviados = cod in mapaEnviados ? mapaEnviados[cod] : solicitados;
      return { ...p, metros_solicitados: solicitados, metros_enviados: enviados };
    });

    handleCargarListaProductos(productos);
    setIsModalOpen(true);
  };
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IDataProducto>[] =
    useMemo<MRT_ColumnDef<IDataProducto>[]>(
      () => [
        {
          accessorKey: 'cantidad_transferido',
          header: '',
          Header: () => <>Cant.<br />Transferido</>,
          size: 140,
          Cell: ({ row }) => {
            const transferido = Number(row.original.cantidad_transferido ?? 0);
            const aprobada = Number(row.original.cantidad_aprobada ?? 0);
            const completo = transferido >= aprobada;
            return (
              <Chip
                label={transferido}
                color={completo ? 'success' : 'warning'}
                size="small"
                variant={completo ? 'filled' : 'outlined'}
                //icon={completo ? <CheckCircleIcon /> : <PendingIcon />}
                sx={{
                  fontWeight: 600,
                  minWidth: 70,
                }}
              />
            );
          }
        },
        {
          accessorKey: 'cantidad',
          header: 'cant. Requerido',
          Header: () => <>Cant.<br />Requerido</>,
          size: 130,
        },
        
        {
          accessorKey: 'codigo',
          header: 'Código',

        },
        {
          accessorKey: 'metros_solicitados',
          header: 'Metros solicitados',
          Header: () => <>Metros<br />solicitados</>,
          size: 130,
          Cell: ({ row }: { row: any }) => {
            const usaMetros = row.original?.cantidad_metros != null && row.original?.cantidad_metros !== '';
            return usaMetros ? Number(row.original.metros_solicitados ?? 0) : 'N/A';
          },
        },
        {
          accessorKey: 'metros_enviados',
          header: 'Metros enviados',
          Header: () => <>Metros<br />enviados</>,
          size: 130,
          Cell: ({ row }: { row: any }) => {
            const usaMetros = row.original?.cantidad_metros != null && row.original?.cantidad_metros !== '';
            if (!usaMetros) return 'N/A';
            const enviados = Number(row.original.metros_enviados ?? 0);
            const solicitados = Number(row.original.metros_solicitados ?? 0);
            const color = enviados > solicitados ? 'success' : enviados < solicitados ? 'warning' : 'default';
            return (
              <Chip label={enviados} color={color as any} size="small" variant="outlined" sx={{ fontWeight: 600, minWidth: 70 }} />
            );
          },
        },
        {
          accessorKey: 'producto_data.descripcion',
          header: 'Descripción',

        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
          Cell: ({ row }: { row: any }) => row.original?.producto_data?.modelo_producto || 'N/A'
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
          Cell: ({ row }: { row: any }) => row.original?.producto_data?.marca_producto || 'N/A'
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
          Cell: ({ row }: { row: any }) => row.original?.producto_data?.categoria_producto || 'N/A'
        },

        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'unida Medida',
          Cell: ({ row }: { row: any }) => row.original?.producto_data?.unidad_medida || 'N/A'
        },
      ],
      []
    );

  const {
    pagination,
    setPagination,
    dateBefore,
    dateAfter,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()

  const {
    data: solicitudPedidosFinalizadosRes,
    isLoading: isLoadingSolicitudesPedidoPaging,
    isRefetching,
  } = useFetchSolicitudesEgreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudPeodidoEnum.FINALIZADO,
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    ...filterObject,
    filterByState: false,

  });
  //**Clear */
  useEffect(() => {
    if (!isModalOpen) {
      clearSelectedItems()
    }
  }, [isModalOpen])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<SolicitudesEgreso>
          columns={columns}
          data={solicitudPedidosFinalizadosRes?.data?.data || []}
          isLoading={isLoadingSolicitudesPedidoPaging}
          isRefetching={isRefetching}
          enableGlobalFilter={false}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosFinalizadosRes?.data?.count}
          actionsColumnSize={120}
          //
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          // crud
          enableColumnActions={true}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Productos"
        onCloseIcon={() => setIsModalOpen(false)}
        minWidth="60%"
        contentNode={
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SampleTablePagination<IDataProducto>
                columns={columnsProductosDetallePedidosDb}
                data={paginatedProductoData}
                rowCount={listaProductos.length}
                pagination={paginationTable}
                setPagination={setpaginationTable}
                rowNumber={true}

              />
              {/*    {details.length > 0 && (
                <SampleTable<IDataProducto>
                  columns={columnsProductosDetallePedidosDb}
                  data={productos}
                />
              )} */}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
}